import React, { useEffect } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";

/**
 * Tiny shared header used by every iCaard registration screen
 * (Customer, Student, Driver, iPrint, Organizer, Food Vendor, Hostel Owner,
 *  and any future role).
 *
 * Renders nothing if no card serial was scanned. When a `serial` is present
 * we show a consistent green "Activation card linked" banner + fire one toast.
 *
 * ⚠️ Convention for future role registrations:
 * Always drop `<ActivationLinkedBanner serial={qrSerial} />` near the top of the
 * form so every role gets the same trusted, on-brand activation receipt.
 */
export function ActivationLinkedBanner({ serial, testId = "activation-linked-banner" }) {
  useEffect(() => {
    if (serial) toast.message("Activation card linked", { description: serial });
  }, [serial]);

  if (!serial) return null;
  return (
    <div
      data-testid={testId}
      className="rounded-xl border border-[#10B981]/40 bg-[#10B981]/10 p-2.5 flex items-center gap-2 text-[11px] text-[#10B981] mb-3"
    >
      <ShieldCheck size={14} className="flex-shrink-0" />
      <span>
        Activation card <span className="font-mono break-all">{serial}</span> will be linked to
        this account
      </span>
    </div>
  );
}

export default ActivationLinkedBanner;
